
import {
  computed, defineComponent, Ref, ref, onMounted,
} from 'vue';
import { useRoute, useRouter } from 'vue-router';
import MessagesConversationItem from './MessagesConversationItem.vue';
import AppItemWrapper from '@/components/AppItemWrapper.vue';
import { useMainStore } from '@/store/mainStore';
import { useMessagesStore } from '../store/messagesStore';
import { IConversationItemDirectList, IConversationItemGroupList } from '@/types/interfaces';
import MessageGroupChatCreate from './MessageGroupChatCreate.vue';
import MessageGroupChatInfo from './MessageGroupChatInfo.vue';
import MonitoringService from '@/services/MonitoringService';
import AppSkeletonContact from '@/components/skeletons/AppSkeletonContact.vue';

export default defineComponent({
  props: {
    conversation: { type: Array as () => (IConversationItemDirectList | IConversationItemGroupList)[], required: true },
    skeleton: { type: Boolean, default: false },
  },
  components: {
    MessagesConversationItem,
    AppItemWrapper,
    MessageGroupChatInfo,
    AppSkeletonContact,
    MessageGroupChatCreate,
  },
  emits: ['open-group-info', 'close-group-info'],
  setup(props, { emit }) {
    const messagesStore = useMessagesStore();

    const showAll: Ref<boolean> = ref(false);

    const isGroupInfo: Ref<boolean> = ref(false);

    const mainStore = useMainStore();

    const createGroup: Ref<boolean> = ref(false);

    const showAllButton = computed(() => props.conversation.length > 3);

    const conversations = computed(() => messagesStore.filteredConversations);

    const route = useRoute();
    const router = useRouter();

    function openGroupInfo(convListItem: IConversationItemGroupList) {
      messagesStore.currentConversation = messagesStore.conversationGroupListToConversation(convListItem);
      isGroupInfo.value = true;
      emit('open-group-info');
    }

    function closeGroupInfo() {
      messagesStore.currentConversation = null;
      isGroupInfo.value = false;
      emit('close-group-info');
    }
    function checkRouterQuery() {
      if (route.query.createGroup) {
        createGroup.value = true;
        router.replace({});
      }
    }

    onMounted(() => {
      checkRouterQuery();
      MonitoringService.sendPageMountedSpeed();
    });

    return {
      messagesStore,
      isGroupInfo,
      conversations,
      showAll,
      showAllButton,
      openGroupInfo,
      closeGroupInfo,
      mainStore,
      createGroup,
    };
  },
});
